import { render, staticRenderFns } from "./xianzhuang.vue?vue&type=template&id=564a5ee9&scoped=true&"
import script from "./xianzhuang.vue?vue&type=script&lang=js&"
export * from "./xianzhuang.vue?vue&type=script&lang=js&"
import style0 from "./xianzhuang.vue?vue&type=style&index=0&id=564a5ee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a5ee9",
  null
  
)

export default component.exports